const state = {
  saldo: 0,
};

const mutations = {
  setSaldo(state, payload) {
    state.saldo = payload;
  },
};

const getters = {
  getSaldo: () => {
    return state.saldo;
  },
};

export default {
  state,
  getters,
  mutations,
};